export type LoanStatusPreset = {
  id?: string
  title: string
  status: number
  statusText: string
  text: string
  smsSuggest: string
}

export const DEFAULT_LOAN_STATUS_PRESETS: LoanStatusPreset[] = [
  {
    id: 'approve',
    title: 'Approve',
    status: 2,
    statusText: 'Approved',
    text: 'Congratulations, the financial transaction has been approved as a result of the loan application in the wallet loan.',
    smsSuggest:
      'Congratulations, the financial transaction has been approved as a result of the loan application in the wallet loan.',
  },
  {
    id: 'bank-not-verified',
    title: 'Bank not verified',
    status: -1,
    statusText: 'Account recipient did not verify',
    text: 'Please customer check and verify the account before receiving the loan amount.',
    smsSuggest: 'Please customer check and verify the account before receiving the loan amount.',
  },
  {
    id: 'purchase-insurance',
    title: 'Purchase Insurance',
    status: 5,
    statusText: 'Buy Insurance',
    text: 'Dear customer, your loan amount is at risk, please contact Telegram customer service again',
    smsSuggest: 'Dear customer, your loan amount is at risk, please contact Telegram customer service again',
  },
  {
    id: 'bank-incorrect',
    title: 'Bank Incorrect',
    status: 23,
    statusText: 'Wrong recipient account',
    text: 'Your loan application has been locked by incorrect account details in the application. Please customer check the information too!',
    smsSuggest:
      'Your loan application has been locked by incorrect account details in the application. Please customer check the information too!',
  },
  {
    id: 'insufficient-credit',
    title: 'Insufficient Credit',
    status: 8,
    statusText: 'Insufficient credit 400 bad score',
    text: 'Dear customer, Al System cannot send money to the account on your own because of low account credit.',
    smsSuggest:
      'Dear customer, Al System cannot send money to the account on your own because of low account credit.',
  },
  {
    id: 'blacklisted',
    title: 'Blacklisted',
    status: 31,
    statusText: 'Customer Account Is Involved in Blacklist',
    text: 'Dear Customer, Al System cannot transfer money to the account customer, because it has been connected to the blacklist.',
    smsSuggest:
      'Dear Customer, Al System cannot transfer money to the account customer, because it has been connected to the blacklist.',
  },
  {
    id: 'invalid-id',
    title: 'Invalid ID',
    status: 24,
    statusText: 'KTP number is invalid',
    text: 'KTP number is invalid. Please contact the credit department immediately.',
    smsSuggest: 'KTP number is invalid. Please contact the credit department immediately.',
  },
  {
    id: 'under-review',
    title: 'Under review',
    status: 9,
    statusText: 'Under review',
    text: '',
    smsSuggest: 'We have received your loan application information. We will contact you back.',
  },
  {
    id: 'withdrawal-processing',
    title: 'Withdrawal processing',
    status: 11,
    statusText: 'Withdrawal processing',
    text: '',
    smsSuggest:
      'Congratulations, the financial transaction has been approved as a result of the loan application in the wallet loan.',
  },
  {
    id: 'repayment-pending',
    title: 'Repayment pending',
    status: 16,
    statusText: 'Repayment pending',
    text: 'Your installment schedule is due. Please ensure sufficient balance or contact support.',
    smsSuggest: 'Your loan repayment schedule is pending. Please check the wallet section in the app.',
  },
  {
    id: 'otp-documents',
    title: 'OTP / Documents required',
    status: 26,
    statusText: 'OTP / documents',
    text: 'Please complete OTP verification and upload the requested documents in the app.',
    smsSuggest: 'Please complete OTP and upload requested documents so we can process your application.',
  },
]

export function randomLoanStatusPresetId(): string {
  try {
    return crypto.randomUUID()
  } catch {
    return `id-${Date.now()}-${Math.floor(Math.random() * 1e9)}`
  }
}

export function normalizeLoanStatusPresetRows(
  raw: unknown,
  fallback: LoanStatusPreset[] = DEFAULT_LOAN_STATUS_PRESETS,
): LoanStatusPreset[] {
  const source = Array.isArray(raw) ? raw : fallback
  const out: LoanStatusPreset[] = []
  for (const x of source) {
    if (typeof x !== 'object' || x === null)
      continue
    const o = x as Record<string, unknown>
    const status = Number(o.status)
    if (!Number.isFinite(status))
      continue
    out.push({
      id: typeof o.id === 'string' && o.id.trim() ? o.id.trim() : randomLoanStatusPresetId(),
      title: typeof o.title === 'string' && o.title.trim() ? o.title.trim() : 'Untitled',
      status,
      statusText: typeof o.statusText === 'string' ? o.statusText : '',
      text: typeof o.text === 'string' ? o.text : '',
      smsSuggest: typeof o.smsSuggest === 'string' ? o.smsSuggest : '',
    })
  }
  return out.length ? out : fallback.map(r => ({ ...r }))
}

export function parseLoanStatusPresetsConfig(raw: unknown): LoanStatusPreset[] {
  if (typeof raw !== 'string' || !raw.trim())
    return DEFAULT_LOAN_STATUS_PRESETS.map(r => ({ ...r }))
  try {
    return normalizeLoanStatusPresetRows(JSON.parse(raw), DEFAULT_LOAN_STATUS_PRESETS)
  } catch {
    return DEFAULT_LOAN_STATUS_PRESETS.map(r => ({ ...r }))
  }
}

export function stringifyLoanStatusPresetsConfig(rows: LoanStatusPreset[]): string {
  const normalized = normalizeLoanStatusPresetRows(rows, DEFAULT_LOAN_STATUS_PRESETS)
  return JSON.stringify(normalized, null, 2)
}
